import { render, staticRenderFns } from "./TodoAddModal.vue?vue&type=template&id=dfccb4d8&scoped=true"
import script from "./TodoAddModal.vue?vue&type=script&lang=js"
export * from "./TodoAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfccb4d8",
  null
  
)

export default component.exports